"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AncestryEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.AncestryEnum = {
    AfricanAmerican: 'african_american',
    Ashkenazi: 'ashkenazi',
    Asian: 'asian',
    Hispanic: 'hispanic',
    Mediterranean: 'mediterranean',
    NativeAmerican: 'native_american',
    PacificIslander: 'pacific_islander',
    Sephardic: 'sephardic',
    White: 'white',
    Other: 'other',
    Unknown: 'unknown'
};
